import { Component, HostListener, OnInit } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { CanComponentDeactivate, DeactivateGuard } from 'src/app/can-deactivate-guard.service';
import { DialogModalService } from 'src/app/shared/dialog-modal/dialog-modal.service';
import { GetIMstHTOrg } from 'src/app/store/actions/mstHTOrg.action';
import { IAppState } from 'src/app/store/states/app.state';
import { LoadingService } from '../../../layout/loading/loading.service';
import { Utility } from '../../../shared/utility/utility';
import { ScrPersonalInfService } from './src-personal-inf.service';

@Component({
  selector: 'app-src-personal-inf',
  templateUrl: './src-personal-inf.component.html',
  styleUrls: ['./src-personal-inf.component.scss']
})
export class SrcPersonalInfComponent implements OnInit, DeactivateGuard {

  constructor(public util: Utility, public trans: TranslateService
            , private service: ScrPersonalInfService
            , private loading: LoadingService
            , private router: Router
            , private store: Store<IAppState>
            , private dialog: DialogModalService) {
            }
  public personalInf: any;
  private compareObj: string;
  strNewEmail: string;
  strNewPass: string;
  maxLength = 255;
  passObj: any;
  objMess: any;
  isValidationError = false;
  isNotKana = false;
  emailValidation = new RegExp('^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$');
  passValidation = RegExp(/^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])[0-9a-zA-Z-!@#$%^&*()_+|~=`{}\[\]:";'<>?,.]{8,}$/);
  rgxKatakanaFullW = /^([ァ-ン]|[０-９])+$/;
  rgxKatakanaHalfW = /^([ｧ-ﾝﾞﾟ]|[0-9])+$/;
  rgxIME = /[\u3000-\u303f\u3040-\u309f\u30a0-\u30ff\uff00-\uff9f\u4e00-\u9faf\u3400-\u4dbf]/g;
  lstPostal: any[];
  inpAddress = 'inpAdress1';
  txt1 = '';
  txt2 = '';
  txt3 = '';
  txt4 = '';
  lstPropRequire = ['Name', 'KanaName', 'DateOfBirth', 'Gender', 'PhoneNum', 'PostalCode', 'Adress1'];
  lstProp = ['NewMail', 'RetypeEmail', 'CurrentPass', 'NewPass', 'ReTypePass', 'VerifyCode'];
  lstAllProp = ['Name', 'KanaName', 'DateOfBirth', 'Gender', 'PhoneNum', 'PostalCode', 'Adress1', 'Adress2'];
  allProps = ['Name', 'KanaName', 'DateOfBirth', 'Gender', 'PhoneNum', 'PostalCode', 'Adress1', 'NewMail', 'RetypeEmail', 'Cert1', 'Cert2', 'Cert3', 'Cert4', 'Password', 'NewPass', 'RenewPass'];
  lstAcceptNumstr = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];
  lstSpecialKeys = ['Backspace', 'ArrowLeft', 'ArrowRight', 'Delete'];
  objErrorRequire: any;
  keyNotAccept = ['Alt', 'KanjiMode', ' '];
  countErr = 1;
  disableIME = ['number', 'number', 'number', 'number'];
  strDOB = '';
  strMailVerify = '';
  @HostListener('window:beforeunload', ['$event']) unloadHandler(event: Event) {
    if (this.CheckEnable()) {
      return false;
    }
    return true;
  }
  setDeactivateState(nextState) {
    if (this.CheckEnable()) {
      const msg = this.trans.instant('MESS_CNF_SAVE_CHANGED');
      this.dialog.openVerificationModal(msg).subscribe(res => {
        if (res.isOk()) {
          this.Save(nextState);
        } else if (res.isNo()) {
          this.ResetAfterSave();
          this.router.navigateByUrl(nextState);
        }
      });
    }
  }
  canDeactivate(
    component: CanComponentDeactivate, route: ActivatedRouteSnapshot, state: RouterStateSnapshot,
    nextState?: RouterStateSnapshot): Observable<boolean>| Promise<boolean> | boolean {
      return !this.CheckEnable();
  }
  ngOnInit(): void {
    const objHTOrg = {
      HTOrgCode: null,
      HTOrgName: null,
    };
    this.store.dispatch(new GetIMstHTOrg(objHTOrg));
    this.personalInf = {};
    this.ReSet();
    this.util.resetZoomBrowser();
    if (this.util.isNullOrEmpty(localStorage.ExamineauthorizationData)){
      this.router.navigateByUrl('/logout');
      return;
    }
    this.Search();
  }
  Search() {
    this.lstPostal = [];
    this.passObj = {PassWord: '', NewPass: '', ReNewPass: ''};
    this.loading.setDisplay(true);
    this.service.getPersonalInf().subscribe(res => {
      if (res) {
        this.personalInf = res;
        this.strDOB = this.personalInf.DateOfBirth;
        this.personalInf.PostalCode = this.util.formatPostal(this.personalInf.PostalCode);
        this.lstPostal = [{Address: this.personalInf.Adress1}];
        this.strMailVerify = this.personalInf.TemporaryEmailAddress;
        this.personalInf.TemporaryEmailAddress = '';
        this.compareObj = JSON.stringify(this.personalInf);
      }
      this.loading.setDisplay(false);
    }, (error) => {
      this.loading.setDisplay(false);
    });
  }
  async CheckEmail() {
    this.ReSet();
    if (await this.ValidationEmail()) {
      this.service.checkEmail(this.personalInf).subscribe(res => {
        if (!this.util.isNullOrEmpty(res)) {
          if (res === 'F') {
            this.objMess.RetypeEmail.strMsg = 'MESS_ERR_USED_MAIL';
            this.objMess.RetypeEmail.isErr = true;
            this.AddErrorBorder('NewMail');
            return;
          } else if (res === 'UF') {
            const mess = this.trans.instant('MESS_WRN_CHANGED_WILLNOT_BEUPDATED_TO_RESV_INF');
            this.dialog.openWarningModal(mess);
            return;
          } else if (res === 'MF') {
            const mess = this.trans.instant('MESS_EXCEPTION_OCCURRED');
            this.dialog.openErrorModal(mess);
            return;
          }
          this.personalInf.NewMailAddressCertCode = res.toString();
          this.strMailVerify = this.personalInf.TemporaryEmailAddress;
          this.dialog.openSuccessModal(this.trans.instant('MESS_INF_NEWMAIL_AUTHENCODE_SENT'));
        } else {
          const mess = this.trans.instant('MESS_EXCEPTION_OCCURRED');
          this.dialog.openErrorModal(mess);
        }
      });
    } else {
      setTimeout(() => {
        this.FocusFirst();
      }, 1);
    }
  }
  GetMsg(pObj: any) {
    let msg: string = this.trans.instant(pObj.strMsg);
    if (!this.util.isNullOrBlank(pObj.strMsg1)) {
      msg = msg.replace('{0}', this.trans.instant(pObj.strMsg1));
    }
    return msg;
  }
  async ValidationEmail(pCheckCode = false) {
    let isValid = true;
    if (this.util.isNullOrEmpty(this.personalInf.TemporaryEmailAddress)) {
      this.objMess.NewMail.strMsg = 'MESS_CMN_ERR_MISS_INPUT_REQUIRED';
      this.objMess.NewMail.strMsg1 = 'STR_NEW_EMAIL';
      this.objMess.NewMail.isErr = true;
      this.AddErrorBorder('NewMail');
      isValid = false;
    } else if (!this.emailValidation.test(this.personalInf.TemporaryEmailAddress)) {
      this.objMess.NewMail.strMsg = 'MESS_ERR_PLS_ENTER_VALID_EMAIL';
      this.objMess.NewMail.strMsg1 = 'STR_NEW_EMAIL';
      this.objMess.NewMail.isErr = true;
      this.AddErrorBorder('NewMail');
      isValid = false;
    }
    if (this.util.isNullOrEmpty(this.strNewEmail)) {
      this.objMess.RetypeEmail.strMsg = 'MESS_CMN_ERR_MISS_INPUT_REQUIRED';
      this.objMess.RetypeEmail.strMsg1 = 'STR_MAIL_CONFRIM';
      this.objMess.RetypeEmail.isErr = true;
      this.AddErrorBorder('RetypeEmail');
      isValid = false;
    } else if (this.util.TrimAll(this.personalInf.TemporaryEmailAddress) === this.personalInf.MailAdress) {
      this.objMess.RetypeEmail.strMsg = 'MESS_ERR_NEWMAIL_SAME_OLDMAIL';
      this.objMess.RetypeEmail.isErr = true;
      this.AddErrorBorder('RetypeEmail');
      isValid = false;
    } else if (!this.util.isNullOrEmpty(this.strNewEmail) && !this.util.isNullOrEmpty(this.personalInf.TemporaryEmailAddress)
        && this.personalInf.TemporaryEmailAddress !== this.strNewEmail) {
      this.objMess.RetypeEmail.strMsg = 'MESS_ERR_NEWMAIL_NOTSAME_CNFNEWMAIL';
      this.objMess.RetypeEmail.isErr = true;
      this.AddErrorBorder('RetypeEmail');
      isValid = false;
    }
    if (pCheckCode) {
      if (this.objMess.NewMail.isErr === false && this.strMailVerify !== this.personalInf.TemporaryEmailAddress) {
        this.objMess.NewMail.strMsg = 'MESS_ERR_NEWMAIL_NOTSAME_AUTHENMAIL';
        this.objMess.NewMail.isErr = true;
        this.AddErrorBorder('NewMail');
        isValid = false;
      }
      if (this.util.isNullOrEmpty(this.txt1) || this.util.isNullOrEmpty(this.txt2)
        || this.util.isNullOrEmpty(this.txt3) || this.util.isNullOrEmpty(this.txt4)) {
        this.objMess.VerifyCode.strMsg = 'MESS_CMN_ERR_MISS_INPUT_REQUIRED';
        this.objMess.VerifyCode.strMsg1 = 'STR_CONFIRM_CODE';
        this.objMess.VerifyCode.isErr = true;
        this.AddErrorBorder('Cert1');
        this.AddErrorBorder('Cert2');
        this.AddErrorBorder('Cert3');
        this.AddErrorBorder('Cert4');
        isValid = false;
      } else if (this.personalInf.NewMailAddressCertCode !== this.GetCertVerify()) {
        this.objMess.VerifyCode.strMsg = 'MESS_ERR_AUTHENCODE_WRONG';
        this.objMess.VerifyCode.isErr = true;
        this.AddErrorBorder('Cert1');
        this.AddErrorBorder('Cert2');
        this.AddErrorBorder('Cert3');
        this.AddErrorBorder('Cert4');
        isValid = false;
      }
      if (!this.util.isNullOrEmpty(this.passObj.PassWord)) {
        if (!(await this.CheckPass())) {
          this.objMess.CurrentPass.isErr = true;
          this.objMess.CurrentPass.strMsg = 'MESS_ERR_WRONG_USING_PW';
          this.AddErrorBorder('Password');
          isValid = false;
        }
      } else {
        this.objMess.CurrentPass.isErr = true;
        this.objMess.CurrentPass.strMsg = 'MESS_CMN_ERR_MISS_INPUT_REQUIRED';
        this.objMess.CurrentPass.strMsg1 = 'STR_CURRENT_PASSWORD';
        this.AddErrorBorder('Password');
        isValid = false;
      }
    }
    return isValid;
  }
  GetCertVerify() {
    return this.txt1 + '' + this.txt2 + '' + this.txt3 + '' + this.txt4;
  }
  ToLowerCase() {
    this.personalInf.TemporaryEmailAddress = this.personalInf.TemporaryEmailAddress?.toLowerCase();
    this.strNewEmail = this.strNewEmail?.toLowerCase();
  }
  CheckKana() {
      return !this.util.isNullOrEmpty(this.personalInf.CountryCode) &&
          (this.personalInf.CountryCode.toLowerCase() === 'ja' || this.personalInf.CountryCode.toLowerCase() === 'jp');
  }
  async ValidationPass() {
    let isValid = true;
    if (this.util.isNullOrBlank(this.passObj.NewPass) && this.util.isNullOrBlank(this.passObj.ReNewPass)) {
      return true;
    }
    let isCorrectPass = true;
    if (this.util.isNullOrBlank(this.passObj.PassWord)) {
      const rpl = this.trans.instant('STR_CURRENT_PASSWORD');
      this.objMess.CurrentPass.isErr = true;
      this.objMess.CurrentPass.strMsg = 'MESS_CMN_ERR_MISS_INPUT_REQUIRED';
      this.objMess.CurrentPass.strMsg1 = 'STR_CURRENT_PASSWORD';
      this.AddErrorBorder('Password');
      isValid = false;
    } else if (!(await this.CheckPass())) {
      this.objMess.CurrentPass.isErr = true;
      this.objMess.CurrentPass.strMsg = 'MESS_ERR_WRONG_USING_PW';
      this.AddErrorBorder('Password');
      isCorrectPass = false;
      isValid = false;
    }
    if (isCorrectPass) {
      if (this.util.isNullOrBlank(this.passObj.NewPass)) {
        this.objMess.NewPass.isErr = true;
        this.objMess.NewPass.strMsg = 'MESS_CMN_ERR_MISS_INPUT_REQUIRED';
        this.objMess.NewPass.strMsg1 = 'STR_NEW_PASSWORD';
        this.AddErrorBorder('NewPass');
        isValid = false;
      } else if (!this.passValidation.test(this.passObj.NewPass)) {
        this.objMess.NewPass.isErr = true;
        this.objMess.NewPass.strMsg = 'MESS_ERR_WRONG_PW_FORMAT';
        this.AddErrorBorder('NewPass');
        isValid = false;
      } else if (this.passObj.NewPass === this.passObj.PassWord) {
        this.objMess.NewPass.isErr = true;
        this.objMess.NewPass.strMsg = 'MESS_ERR_NEWPW_SAME_OLDPW';
        this.AddErrorBorder('NewPass');
        isValid = false;
      }
      if (this.util.isNullOrBlank(this.passObj.ReNewPass)) {
        this.objMess.ReTypePass.isErr = true;
        this.objMess.ReTypePass.strMsg = 'MESS_CMN_ERR_MISS_INPUT_REQUIRED';
        this.objMess.ReTypePass.strMsg1 = 'STR_CONFIRM_PASSWORD';
        this.AddErrorBorder('RenewPass');
        isValid = false;
      } else if (this.passObj.NewPass !== this.passObj.ReNewPass) {
        this.objMess.ReTypePass.isErr = true;
        this.objMess.ReTypePass.strMsg = 'MESS_ERR_NEW_PW_NOT_SAME';
        this.AddErrorBorder('RenewPass');
        isValid = false;
      }
    }
    return isValid;
  }
  ReSet() {
    this.countErr = 1;
    this.isValidationError = false;
    this.objMess = {};
    this.objErrorRequire = {};
    for (const p of this.lstPropRequire) {
      this.objErrorRequire[p] = {isError: false, strMsg: '', strMsg1: ''};
    }
    for (const p of this.lstProp) {
      this.objMess[p] = {isErr: false, strMsg: '', strMsg1: ''};
    }
    for (const p of this.allProps) {
      this.RemoveErrorBorder(p);
    }
  }
  Validation(pProp: string) {
    if (this.util.isNullOrBlank(this.personalInf[pProp]) && pProp !== 'DateOfBirth' && pProp !== 'KanaName') {
      this.objErrorRequire[pProp].strMsg1 = this.GetMessage(pProp);
      this.objErrorRequire[pProp].strMsg = 'MESS_CMN_ERR_MISS_INPUT_REQUIRED';
      this.objErrorRequire[pProp].isError = true;
      this.isValidationError = true;
      this.AddErrorBorder(pProp);
      return false;
    } else {
      switch (pProp) {
        case 'KanaName':
          if (this.CheckKana()) {
            if (this.util.isNullOrBlank(this.personalInf[pProp])) {
              this.objErrorRequire[pProp].strMsg1 = this.GetMessage(pProp);
              this.objErrorRequire[pProp].strMsg = 'MESS_CMN_ERR_MISS_INPUT_REQUIRED';
              this.objErrorRequire[pProp].isError = true;
              this.isValidationError = true;
              this.AddErrorBorder(pProp);
              return false;
            } else {
              this.isNotKana = !this.rgxKatakanaFullW.test(this.util.ReplaceAll(this.personalInf[pProp], '　', ''));
              if (this.isNotKana) {
                this.objErrorRequire[pProp].strMsg = 'MESS_ERR_KANA_ONLY';
                this.objErrorRequire[pProp].strMsg1 = 'STR_KANA_NAME';
                this.objErrorRequire[pProp].isError = true;
                this.isValidationError = true;
                this.AddErrorBorder(pProp);
                return false;
              }
            }
          }
          return true;
        case 'DateOfBirth':
          if (this.util.isNullOrBlank(this.strDOB)){
            this.objErrorRequire[pProp].strMsg1 = this.GetMessage(pProp);
            this.objErrorRequire[pProp].strMsg = 'MESS_CMN_ERR_MISS_INPUT_REQUIRED';
            this.objErrorRequire[pProp].isError = true;
            this.isValidationError = true;
            this.AddErrorBorder(pProp);
            return false;
          }
          return true;
        default:
          return true;
      }
    }
  }
  GetMessage(pProp: string) {
    switch (pProp) {
      case 'Name':
        return 'STR_NAME';
      case 'KanaName':
        return 'STR_KANA_NAME';
      case 'Gender':
        return 'STR_GENDER';
      case 'DateOfBirth':
        return 'STR_DATEOFBIRTH';
      case 'PhoneNum':
        return 'STR_PHONENUM';
      case 'PostalCode':
        return 'STR_POSTALNUM';
      case 'Address1':
        return 'STR_ADDRESS';
    }
  }
  async ValidationBeforeSave() {
    let ret = true;
    let isChange = false;
    this.ReSet();
    const objComp = JSON.parse(this.compareObj);
    for (const p of this.lstPropRequire) {
      if (this.util.TrimAll(this.personalInf[p]) !== this.util.TrimAll(objComp[p]) || (p === 'DateOfBirth' && this.strDOB !== objComp[p])) {
        isChange = true;
        if (!this.Validation(p)) {
          ret = false;
        }
      }
    }
    if (!this.util.isNullOrBlank(this.personalInf.TemporaryEmailAddress) || !this.util.isNullOrBlank(this.strNewEmail)) {
      const isValid = await this.ValidationEmail(true);
      if (ret) {
        ret = isValid;
      }
    }
    if (!this.util.isNullOrBlank(this.passObj.NewPass) || !this.util.isNullOrBlank(this.passObj.ReNewPass)) {
      const isValid = await this.ValidationPass();
      if (ret) {
        ret = isValid;
      }
      if (ret && !this.util.isNullOrBlank(this.passObj.NewPass)) {
        this.personalInf.NewPass = window.btoa(this.passObj.NewPass);
      }
    }
    if (isChange && ret) {
      const dataRes = await this.service.checkUserResevation().toPromise();
      if (dataRes === 'F') {
        const mess = this.trans.instant('MESS_WRN_CHANGED_WILLNOT_BEUPDATED_TO_RESV_INF');
        const waitObj = await this.dialog.openWarningModal(mess).toPromise();
        if (waitObj.isOk()) {
          return true;
        }
        return false;
      } else {
        return true;
      }
    }
    this.isValidationError = !ret;
    return ret;
  }
  async CheckPass() {
    try {
      const check = await this.service.checkPass({Password: window.btoa(this.passObj.PassWord)}).toPromise();
      return check === 'S';
    } catch (error) {
      const mess = this.trans.instant('MESS_EXCEPTION_OCCURRED');
      this.dialog.openErrorModal(mess);
      return false;
    }
  }
  async SearchAddress() {
    this.lstPostal = await this.util.GetAddress(this.personalInf.PostalCode);
    this.FocusItem('Address1');
  }
  fcNumber(event: any, pIndx: number){
    this.disableIME[pIndx] = event.target.type = 'text';
    const m = $(event.target).val().toString().length;
    event.target.setSelectionRange(m, m);
  }
  fcoNumber(pVal: string, pIdx: number){
    if (!this.util.isNullOrBlank(pVal) && pVal.length === 1){
        this.disableIME[pIdx] = 'text';
    } else{
        this.disableIME[pIdx] = 'number';
    }
  }
  numberOnly(event: any, pId = '') {
    if (this.lstSpecialKeys.includes(event.key)){
      return true;
    }
    if (this.lstAcceptNumstr.includes(event.key)) {
      if (!this.util.isNullOrEmpty(pId)) {
        setTimeout(() => {
          this.FocusItem(pId);
        }, 1);
      }
      return true;
    }
    return false;
  }
  InputCert(event: any, pId: string, pProp: string) {
    this.RemoveErrorBorder(pId);
    this.FocusItem(pId);
    this.objMess[pProp] = {isError: false, strMsg: ''};
    switch (pId) {
      case 'Cert1':
        this.txt1 = event.target.value.trim();
        break;
      case 'Cert2':
        this.txt2 = event.target.value.trim();
        break;
      case 'Cert3':
        this.txt3 = event.target.value.trim();
        break;
      case 'Cert4':
        this.txt4 = event.target.value.trim();
        break;
    }
  }
  FocusItem(pItem: string) {
    const el = document.getElementById('inp' + pItem);
    if (el) {
      setTimeout(() => {
        el.focus();
      }, 1);
    }
  }
  RemoveCommon(pItem: string) {
    this.RemoveErrorBorder(pItem);
    this.objErrorRequire[pItem] = {isErr: false, strMsg: ''};
  }
  RemoveUnCommon(pItem: string) {
    this.RemoveErrorBorder(pItem);
    this.objMess[pItem] = {isError: false, strMsg: ''};
  }
  FocusFirst() {
    const els = document.getElementsByClassName('ClsCount1');
    if (els.length > 0) {
      const el = els[0] as HTMLElement;
      if (el) {
        setTimeout(() => {
          console.log(el.id);
          el.focus();
        }, 1);
      }
    }
  }
  AddErrorBorder(pItem: string){
    const strClsCount = 'ClsCount' + this.countErr;
    $('#inp' + pItem).addClass('error-border');
    $('#inp' + pItem).addClass(strClsCount);
    this.countErr++;
  }
  RemoveErrorBorder(pItem: string) {
    const strId = 'inp' + pItem;
    $('#' + strId).removeClass('error-border');
    const Clss = $('#' + strId).attr('class');
    if (Clss) {
      const allCls = Clss.split(' ');
      const cls = allCls.find(e => e.indexOf('ClsCount') > -1);
      if (cls) {
        $('#inp' + pItem).removeClass(this.util.ReplaceAll(cls, ' ', ''));
      }
    }
  }
  ChangeDOB(pDate: string) {
    this.strDOB = this.util.ReplaceAll(pDate, '-', '');
  }
  RemoveDOB() {
    this.strDOB = '';
  }
  SetValue(pVal: string, pProp: string) {
    this.RemoveErrorBorder(pProp);
    this.personalInf[pProp] = pVal;
  }
  CheckEnable() {
    const strObj = JSON.stringify(this.personalInf);
    if (strObj !== this.compareObj) {
      return true;
    }
    if (!this.util.isNullOrBlank(this.passObj.PassWord + this.passObj.NewPass + this.passObj.ReNewPass)
        || (this.personalInf.NewMailAddressCertCode !== this.GetCertVerify() && this.GetCertVerify() !== '')
        || (!this.util.isNullOrBlank(this.strNewEmail) && !this.util.isNullOrBlank(this.personalInf.TemporaryEmailAddress))
        || this.util.isNullOrEmpty(this.strDOB) || this.personalInf.DateOfBirth !== this.strDOB) {
          return true;
    }
    return false;
  }
  MaskPass(e: any, pProp: string) {
    let nowVal = e.target.value;
    const kanaText = e.data;
    if (e.which === 32) {
      nowVal = nowVal?.replace(/\s/g, '');
    }
    if (this.check2ByteFunc(kanaText)) {
      nowVal = nowVal?.replace(kanaText, '');
    }
    e.target.value = nowVal.replace(this.rgxIME, '');
    const el = e.target as HTMLElement;
    if (el) {
      el.classList.remove('error-border');
      const allCls = el.className.split(' ');
      const cls = allCls.find(c => c.indexOf('ClsCount') > -1);
      if (cls) {
        el.classList.remove(cls);
      }
    }
    if (pProp === 'PassWord') {
      this.objMess.CurrentPass = {isError: false, strMsg: ''};
    } else if (pProp === 'NewPass') {
      this.objMess.NewPass = {isError: false, strMsg: ''};
    }  else{
      this.objMess.ReTypePass = {isError: false, strMsg: ''};
    }
  }
  check2ByteFunc(val) {
    const actualLen = val?.length;
    const strLen = this.countLength(val);
    // tslint:disable-next-line: radix
    if (parseInt(actualLen) * 2 === strLen) {
      return true;
    }
    return false;
  }
  countLength(str) {
    let r = 0;
    for (let i = 0; i < str?.length; i++) {
      const c = str.charCodeAt(i);
      // Shift_JIS: 0x0 ～ 0x80, 0xa0 , 0xa1 ～ 0xdf , 0xfd ～ 0xff
      // Unicode : 0x0 ～ 0x80, 0xf8f0, 0xff61 ～ 0xff9f, 0xf8f1 ～ 0xf8f3
      if ((c >= 0x0 && c < 0x81) || (c === 0xf8f0) || (c >= 0xff61 && c < 0xffa0) || (c >= 0xf8f1 && c < 0xf8f4)) {
        r += 1;
      } else {
        r += 2;
      }
    }
    return r;
  }
  onPaste(event: ClipboardEvent, pProp: string) {
    const clipboardData = event.clipboardData || (window as any).clipboardData;
    let pastedText: string = clipboardData.getData('text');
    if (pastedText.length > 16) {
      pastedText = pastedText.substring(0, 16);
    }
    if (!this.passValidation.test(pastedText)){
      event.preventDefault();
    } else {
      this.passObj[pProp] = pastedText;
    }
  }
  Return() {
    if (this.CheckEnable()) {
      const msg = this.trans.instant('MESS_CNF_SAVE_CHANGED');
      this.dialog.openVerificationModal(msg).subscribe(res => {
        if (res.isOk()) {
          this.Save();
        } else if (res.isNo()) {
          this.ResetAfterSave();
          this.router.navigateByUrl('/toppage');
        }
      });
    } else {
      this.router.navigateByUrl('/toppage');
    }
  }
  async Save(pUrl = ''){
    if (await this.ValidationBeforeSave()) {
      this.personalInf.DateOfBirth = this.strDOB;
      this.personalInf.PostalCode = this.util.TrimAll(this.personalInf.PostalCode);
      //20230918 #18640 add strat
      this.personalInf.PostalCode = this.personalInf.PostalCode.replace(/[^\d.]/g,"");
      //20230918 #18640 add end
      this.loading.setDisplay(true);
      try {
        const res = await this.service.updPesonalInf(this.personalInf).toPromise();
        this.loading.setDisplay(false);
        if (res) {
          let mess = this.trans.instant('MESS_CMN_INF_REGIS_SUCCESS');
          if (res === 'F') {
            mess = this.trans.instant('MESS_ERR_APPLICAPLE_DATA_NOT_EXIST');
            this.dialog.openErrorModal(mess).toPromise();
            return;
          }
          this.dialog.openSuccessModal(mess).toPromise();
          this.ResetAfterSave();
          if (this.util.isNullOrBlank(pUrl)) {
            this.router.navigateByUrl('/toppage');
          } else {
            this.router.navigateByUrl(pUrl);
          }
        }
      } catch (error) {
        this.loading.setDisplay(false);
        const msg = this.trans.instant('MESS_EXCEPTION_OCCURRED');
        this.dialog.openErrorModal(msg);
      }
    } else {
      setTimeout(() => {
        this.FocusFirst();
      }, 1);
    }
  }
  ResetAfterSave() {
    this.compareObj = JSON.stringify(this.personalInf);
    this.txt1 = this.txt2 = this.txt3 = this.txt4 = '';
    this.strDOB = this.personalInf.DateOfBirth;
    this.passObj = {PassWord: '', NewPass: '', ReNewPass: ''};
    this.strNewEmail = '';
  }
  noSpace(event: any){
    if (event.which === 32 || event.key === 'KanaMode') {
      event.target.value = '';
      event.preventDefault();
    } else {
      const keyValues = event.target.value.trim();
      event.target.value = keyValues.replace(this.rgxIME, '');
    }
  }
}
